import { useState, useEffect } from 'react';
import { isDarkMode, setDarkMode, onThemeChange } from '../lib/theme';

/**
 * React hook for dark mode.
 *
 * Returns [isDark, toggle] where toggle() flips the mode.
 * Forces a re-render when the theme changes.
 */
export function useDarkMode() {
  const [dark, setDark] = useState(isDarkMode);

  useEffect(() => {
    return onThemeChange((d) => setDark(d));
  }, []);

  const toggle = () => setDarkMode(!dark);

  return [dark, toggle];
}
